const i=(i,t,c)=>i.toLocaleString("en-US",{style:"currency",currency:t,minimumFractionDigits:0,maximumFractionDigits:2,...c});export{i as formatCurrency};
//# sourceMappingURL=formatCurrency.js.map
